import React from "react";
import PropTypes from "prop-types";

export const isDateString = (val) =>
  typeof val === "string" && /^\d{4}-\d{2}-\d{2}(T.*)?$/.test(val.trim());

export const isNumericString = (val) =>
  typeof val === "string" && /^-?\d+(\.\d+)?$/.test(val.trim());

export const compareValuesAsc = (valA, valB) => {
  const aEmpty =
    valA === null || valA === undefined || valA === "" || valA === "-";
  const bEmpty =
    valB === null || valB === undefined || valB === "" || valB === "-";

  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;

  if (isDateString(valA) && isDateString(valB)) {
    return new Date(valA) - new Date(valB);
  }

  if (
    (typeof valA === "number" || isNumericString(valA)) &&
    (typeof valB === "number" || isNumericString(valB))
  ) {
    return parseFloat(valA) - parseFloat(valB);
  }

  return String(valA).localeCompare(String(valB), undefined, {
    numeric: true,
    sensitivity: "base",
  });
};
export const compareValuesAscGrp = (valA, valB) => {
  const aEmpty =
    valA === null || valA === undefined || valA === "" || valA === "-";
  const bEmpty =
    valB === null || valB === undefined || valB === "" || valB === "-";
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;

  if (isDateString(valA) && isDateString(valB)) {
    return new Date(valA) - new Date(valB);
  }

  if (
    (typeof valA === "number" || isNumericString(valA)) &&
    (typeof valB === "number" || isNumericString(valB))
  ) {
    return parseFloat(valA) - parseFloat(valB);
  }

  return String(valA).localeCompare(String(valB), undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const smartSortingFn = (rowA, rowB, columnId) => {
  return compareValuesAsc(rowA.getValue(columnId), rowB.getValue(columnId));
};

export const SortableHeader = ({ label, column }) => {
  const sorted = column.getIsSorted();

  return (
    <div
      onClick={column.getToggleSortingHandler()}
      style={{
        cursor: "pointer",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        gap: 6,
      }}
      title="Click to sort"
    >
      <span>{label}</span>
      <span
        style={{
          display: "inline-flex",
          flexDirection: "column",
          lineHeight: "8px",
        }}
      >
        <i
          className="fa fa-caret-up"
          style={{
            fontSize: 11,
            color: sorted === "asc" ? "#1B2850" : "#c9c9c9",
          }}
        />
        <i
          className="fa fa-caret-down"
          style={{
            fontSize: 11,
            color: sorted === "desc" ? "#1B2850" : "#c9c9c9",
          }}
        />
      </span>
    </div>
  );
};

SortableHeader.propTypes = {
  label: PropTypes.string.isRequired,
  column: PropTypes.object.isRequired,
};
